<template>
    <div>
        <!-- slot="reference" -->
        <div v-if="isType=='2'" class=" btn-item color-2" :class="{marLeft:isMarleft}"  @click="dialogVisible = true">{{btnText}}</div>
        <div v-if="isType=='1'" class=" btn-item color-1" :class="{marLeft:isMarleft}"  @click="dialogVisible = true">{{btnText}}</div>
        <div v-if="isType=='0'" class=" btn-item color-0" :class="{marLeft:isMarleft}"  @click="dialogVisible = true">{{btnText}}</div>
        <el-dialog
            custom-class="myDialog"
            :visible.sync="dialogVisible"
            :modal="modal"
            title="提示" 
            width="400px"
            center
            top="30vh"
            @opened="opened()"
            @open="open()"
            @close="close"
            :append-to-body='appendToBody'
            >
            <div class="main-line"></div>
            <div class="main" v-if="!cancelExecution">
                <div v-if="!isReject">
                    <div class="reject-no">
                        <i style="color:rgb(230, 162, 60);font-size: 20px;margin-right: 10px;" class="el-icon-warning" ></i>
                        <span style="font-size: 14px;">{{centerText}}</span>       
                        <div class="descriptive-text">{{ descriptiveText }}</div>       
                    </div>
                </div>
                <div v-else >
                    <div class="reject-top">
                        <i style="color:rgb(230, 162, 60);font-size: 20px;margin-right: 10px;" class="el-icon-warning" ></i>
                        <span style="font-size: 14px;">{{centerText}}</span>
                        <div class="descriptive-text">{{ descriptiveText }}</div>       
                    </div>
                    <div class="reject-area">
                        <div class="area-left">退回理由</div>
                        <el-input
                            class="area-right"
                            v-model="rejectAccount"   
                            type="textarea"
                            :rows="2"
                            placeholder="请填写退回理由"
                            >
                        </el-input>
                    </div>
                </div>
            </div>
            <div class="main" v-else>
                <div class="reject-top-red">
                    <i style="color:rgb(230, 162, 60);font-size: 20px;margin-right: 10px;" class="el-icon-warning" ></i>
                    <span style="font-size: 14px;">{{centerText}}</span>
                </div>
                <div class="reject-red">
                    取消执行后，额度自动释放
                </div>
            </div>
            <div class="main-line"></div>
            <div style="height: 10px;"></div>
            <span slot="footer" class="dialog-footer">
                <el-button  size="small" @click="noSure()">取 消</el-button>
                <el-button  size="small" type="danger" @click="beSure()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
    export default {
      name: 'dialog-pop',
      props: {
        centerText:{type:String, default:'' },
        descriptiveText:{type:String, default:'' },
        isType:{type:String, default:'' }, // 0 白字红框红底  1 红字红框白底   2 白字蓝框蓝底
        btnText:{type:String, default:'' },
        marLeft:{type:Boolean,default:false},
        modal:{type:Boolean,default:true},
        isReject:{type:Boolean,default:false},
        cancelExecution:{type:Boolean,default:false},
        appendToBody:{type:Boolean,default:false},
      },
      data () {
        return {
            dialogVisible: false,
            isMarleft: false,
            rejectAccount:'', //拒绝理由
        }
      },
      computed: {
      },
      watch: {},
      created () {
        if (this.marLeft) {
            this.isMarleft = true
        }
        this.init()
      },
      mounted () {},
      updated () {
      },
      methods: {
        init () {},
        close () {
            this.dialogVisible = false
            this.$emit('closeOpen')
        },
        // 确定
        beSure () {
            if (!this.isReject) {
                this.dialogVisible = false
                this.$emit('confirm')
            } else {
                this.dialogVisible = false
                this.$emit('getRejectaccount',this.rejectAccount)
                this.$emit('confirm')
            }
        },
        noSure () {
            this.dialogVisible = false
            this.$emit('closeOpen')
        },
        open () {
            this.$emit('open')
        },
        opened () {
            this.$emit('opened')
        },
    }
}
</script>
<style lang="scss" scoped>
.descriptive-text{
    color:$base-red;
    font-size: 14px;
    margin-left: 30px;
    line-height: 20px;
}
</style>
<style lang="scss" scoped>

::v-deep .el-dialog__header {
    text-align: left;
    border-bottom: 0px;
    font-weight: normal;
}
::v-deep .el-dialog--center .el-dialog__body {

    text-align: left;
    padding: 0px !important;
    font-size: 14px;
    font-weight: normal;
}
::v-deep .el-dialog__footer {
    text-align: right !important;
    border-top: 0px;
    padding: 0px 20px 10px !important;
  .el-button {
    width: 70px;
  }
}
.btn-item {
    min-width: 64px;
    padding: 0px 10px;
    font-size: 14px;
    font-weight: normal;
    border-radius: 4px;
    text-align: center;
    cursor: pointer;
}
.color-0 {
    background-color: rgba(205, 18, 49, 1);
    color: rgba(255, 255, 255, 1);
    border: 1px solid rgba(205, 18, 49, 1);
}
.color-1 {
    background-color: rgba(255, 255, 255, 1);
    color: rgba(205, 18, 49, 1);
    border: 1px solid rgba(205, 18, 49, 1);
}
.color-2 {
    background-color: #539EFE;
    color: rgba(255, 255, 255, 1);
    border: 1px solid #539EFE;
}
.marLeft {
    margin-right: 15px;
}
.main {
    padding: 5px 20px 10px ;
    margin-bottom: 2px;
}
.reject-top {
    margin: 10px 0px 10px 0px;
}
.reject-area {
    display:flex ;
    padding-bottom: 10px;
    .area-left {
        width: 70px;
        margin-right:0px;
        line-height: 31px;
    }
    .area-right {
        width: 245px;
    }
}
.reject-top-red {
    margin: 10px 0px 0px 0px;
}
.reject-red {
    font-size: 13px;
    margin-top: -10px;
    padding-left: 30px;
    padding-bottom: 10px;
    color: #cd1231;
}
.reject-no {
    padding: 20px 0px;
}
.main-line{
    height: 1px;
    width: 100%;
    background-color: #BBBBBB;
    opacity: 0.27;
    // border: 1px solid rgba(187, 187, 187, 1);
}
</style>
